var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.slice.primary.content.length)?_c('Section',{attrs:{"width":"md"}},[_c('p',[_vm._v(_vm._s(_vm.slice.primary.content))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }